export default "/images/success_popup.svg?a0c39fc628746e382beb8173216901b4";